module.exports = __webpack_public_path__ + "static/media/FY20157APT_EBOOK_APPS_PDF_Historia-da-Oracle-Cloud---Apl.6632fc7e.pdf";